import ProductCategoryPage from "@/components/ProductCategoryPage";
import { productPages } from "@/data/productPages";
export default function FoodPackaging() { return <ProductCategoryPage data={productPages.packaging} />; }
